import { gql } from 'graphql-request';

import {
  CustomFieldValueCompanyID,
  CustomFieldValueDefaultAt,
  CustomFieldValueID,
  CustomFieldValueText
} from '../customFieldValuesTypes';

export interface FetchCacheCustomFieldValuesQueryResponse {
  companyId: CustomFieldValueCompanyID;
  defaultAt: CustomFieldValueDefaultAt;
  id: CustomFieldValueID;
  text: CustomFieldValueText;
}

export const FETCH_CACHE_CUSTOM_FIELD_VALUES_QUERY = gql`
  query CacheCustomFieldValues(
    $filters: CustomFieldValuesFilters
    $sort: [CustomFieldValuesSortEnum!]
    $limit: Int
    $offset: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    customFieldValues(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        companyId
        defaultAt
        id
        text
      }
      paginationInfo {
        currentPage
        firstPage
        lastPage
        limitValue
        nextPage
        outOfRange
        prevPage
        totalCount
        totalPages
      }
      sql
    }
  }
`;
